import { STATIC_STRINGS } from "../../../../../utils/Constants";
import ScheduleOptions from "./ScheduleOptions";

const AssignmentSchedule = () => {
  return (
    <>
      <div className="text-lg px-2 font-semibold">
        {STATIC_STRINGS.ASSIGNMENT_SCHEDULE}
      </div>
      <ScheduleOptions />
    </>
  );
};
export default AssignmentSchedule;
